export default {
    breadcrumbs: {
        practice: 'Practice',
        practice_billing: 'Plan & Billing',
    },

    titles: {
        plan_billing: '{practiceName} Plan & Billing',
    },
    active_plan: 'Your active plan',
    cancel_subscription: 'Cancel subscription',
    billing_side_info: 'Connect with your network and make free referrals.',
    billing_side_info_premium:
        'Preferred network for specialists and ancillary services. Build your network, make and receive quality referrals',
    appointment_fee: 'Concierge appointment fee is $.95 for referral received.',
    free_trial_ends: 'Free trial ends on {date}',
    upgrade_now: 'Upgrade to receive referrals',
    subscription_canceled: 'Subscription canceled!',
    subscription_created: 'Subscribed to PREMIUM plan successfully!',
    billing_list: {
        item_1: 'Search and match providers',
        item_2: 'Make FREE referrals',
        item_3: 'Track referrals',
        item_4: '24/7 access to records',
        item_5: 'Provider-Provider messaging',
        item_6: 'Built your network',
        item_7: 'No contract needed',
        item_8: 'Engage new patients in mobile app',
        item_9: 'Send digital referrals to patients',
    },
    cancel_subscription_info:
        'If you cancel you will not be able to receive referrals on the platform.  Your annual PREMIUM subscription fee will not be refunded. You will be downgraded to Network plan where you can still search providers and services and make referrals.',
    plan_type: 'PLAN TYPE',
    monthly: 'monthly',
    annually: 'annually',
    you_save: 'You save ',
    year: 'year',
    payment_form_list: {
        item_1: 'Search and match providers',
        item_2: 'Make and RECEIVE  referrals',
        item_3: 'Track referrals',
        item_4: '24/7 access to records',
        item_5: 'Provider-Provider messaging',
        item_6: 'Built your network',
        item_7: 'EMR integration',
        item_8: 'Referral analytics',
        item_9: 'Engage patients in mobile app',
        item_10: 'Send digital referrals to patients in app',
    },
    invite_new_member_warning:
        'A subscription is charged for each provider you add to your practice. Non-provider practice members are added at no additional charge. Please confirm you agree with this!',
    add_location_warning:
        'A subscription is charged for each new location you add to your practice. Please confirm you agree with this!',
    see_plans: 'See plans',
    registration_billing_info:
        'After your fourteen day Free Premium trial you will have an option to continue with PREMIUM plan or downgrade to the NETWORK plan for FREE.',
}
